import React, { useContext } from 'react';
import { AuthContext } from 'Contexts/AuthContext';

const AuthReady = ({ children }: { children: React.ReactNode }) => {
  const { loading } = useContext(AuthContext);
  return loading ? null : <>{children}</>;
};

export default AuthReady;
